export default __webpack_public_path__ + "static/media/Proceeding@32.99fd5244.svg";